const items = document.querySelectorAll('.menu-item-has-children');
const HOVER_DELAY = 100; // milliseconds before showing/hiding submenu

window.addEventListener('modal:close', e => {
  if (e.target.id === 'nav') {
    items.forEach(item => item.classList.remove('is-open'));
  }
})

items && items.forEach(item => {
  const subMenu = item.lastElementChild;
  const link = item.firstElementChild;
  let hoverTimer = null;
  let isHovering = false;

  // Add back button to submenu
  subMenu.insertAdjacentHTML('afterbegin', `<li class="nav__back"><a href="#">${link.innerHTML}</a></li>`);

  // Handle click for mobile/accessibility
  link.addEventListener('click', e => {
    e.preventDefault();
    items.forEach(item => item.classList.toggle('is-open', link.closest('.menu-item') === item));
  });

  // // Handle hover intent
  // item.addEventListener('mouseenter', () => {
  //   clearTimeout(hoverTimer);
  //   if (!isHovering) {
  //     hoverTimer = setTimeout(() => {
  //       item.classList.add('is-hover');
  //       isHovering = true;
  //     }, HOVER_DELAY);
  //   }
  // });
  //
  // item.addEventListener('mouseleave', () => {
  //   clearTimeout(hoverTimer);
  //   if (isHovering) {
  //     hoverTimer = setTimeout(() => {
  //       item.classList.remove('is-hover');
  //       isHovering = false;
  //     }, HOVER_DELAY);
  //   }
  // });
});

const backLinks = document.querySelectorAll('.nav__back a');

backLinks && backLinks.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    const menuItem = link.closest('.menu-item');
    menuItem.classList.remove('is-open');
    menuItem.classList.remove('is-hover');
  });
});
